import { CacheService } from "@/services/CacheService";
import { useEffect, useState } from "react";

export const useCachedResource = <T>(
  id: string | undefined,
  resourceType: string,
  fetchFn: (id: string) => Promise<T>
) => {
  const [data, setData] = useState<T | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) {
        setError(new Error('ID is not provided'));
        return;
      }

      setIsLoading(true);
      try {
        const cachedData = await CacheService.get(id, resourceType, fetchFn);
        setData(cachedData);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch data'));
        setData(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id, resourceType, fetchFn]);

  return { data, isLoading, error };
};